export default __webpack_public_path__ + "static/media/back2.cbf28259.mp4";